import { jsxs, jsx } from 'react/jsx-runtime';
import { Tooltip, Tag, Text } from '@flex-design-system/fx';

function JobRoleExtraTag({ jobRoles }) {
  if (jobRoles.length < 2) {
    return null;
  }
  const countContent = `+${jobRoles.length - 1}`;
  return /* @__PURE__ */ jsxs(Tooltip, { children: [
    /* @__PURE__ */ jsx(Tooltip.Trigger, { asChild: true, children: /* @__PURE__ */ jsx(
      Tag,
      {
        variant: "weak",
        size: "small",
        color: "grayDark",
        css: { cursor: "default" },
        children: countContent
      }
    ) }),
    /* @__PURE__ */ jsx(Tooltip.Content, { css: { maxWidth: 172 }, side: "top", children: /* @__PURE__ */ jsx(Text, { inherit: true, children: jobRoles.slice(1).map((jobRoe) => jobRoe.name).join(", ").trim() }) })
  ] });
}

export { JobRoleExtraTag as default };
//# sourceMappingURL=JobRoleExtraTag.mjs.map
